import React from "react";
import DataTable from "../Reusable/DataTable";
import APIS from "../../constant/Endpoint";
import NACell from "../Reusable/DataTable/NACell";
// import TableSettingLayout from "../Reusable/DataTable/TableSettingLayout";
import { useNavigate } from "react-router-dom";
import ResetIcon from "../../Icons/ResetIcon";

const TemplateList = () => {
  const navigate = useNavigate();
  const handleRowClick = (row: any) => {
    navigate(`edit/${row.original.id}`);
  };

  const defaultColumns = [
    {
      header: "Name",
      accessorKey: "name",
      cell: NACell,
    },
    {
      header: "Slug",
      accessorKey: "slug",
      cell: NACell,
    },
    {
      header: "Description",
      accessorKey: "description",
      cell: NACell,
    },
    // {
    //   header: "Action",
    //   accessorKey: "id",
    //   cell: ({ getValue }) => (
    //     <TableActionButton editPath={`edit/${getValue()}`} />
    //   ),
    // },
  ];

  return (
    <DataTable
      url={APIS.TEMPLATE}
      queryKey="templates"
      resetUrl={APIS.TEMPLATE_RESET}
      actionMenu={<ResetIcon height="16" width="16" color="black" />}
      columns={defaultColumns}
      params={{}}
      addNewPagePath="/templatelist/create"
      tableName={"templates"}
      onRowClick={handleRowClick}
    />
  );
};

export default TemplateList;
